(function ($) {
  'use strict';

  // Cycle images function.
  function cycleImages() {
    // Get active element.
    var $active = $('.crossfade--item.active');

    // Get next element after the active element. On the last element it is
    // the first element in the container.
    var $next = ($('.crossfade--item.active').next().length > 0) ? $('.crossfade--item.active').next() : $('.crossfade--item:first');

    // Move the next image up the pile.
    $next.css('z-index', 2);

    // Fade out the top image.
    $active.fadeOut(3000, function () {
      // Reset the z-index and unhide the image.
      $active.css('z-index', 1).show().removeClass('active');

      // Make the next image the top one.
      $next.css('z-index', 3).addClass('active');
    });
  }

  $(document).ready(function () {
    // Cycle images each 6s with a fade in time of 3s.
    // Set the first element active.
    $('.crossfade--item:first').addClass('active');

    // Fade in the complete container.
    $('.crossfade--items').fadeIn(2000);

    // Start timer function to cycle images.
    setInterval(cycleImages, 4000);
  });
})(jQuery);
